'use client';

import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { loadForMeasuring, measureHero } from '@/lib/heroContrast';

/**
 * Extra darkening over the banner photo, only as much as this photo needs
 * for the text to read (lib/heroContrast). Measured again when the banner
 * changes shape (phone vs desktop crop differently).
 */
export default function HeroScrim({ src }) {
  const ref = useRef(null);
  const [extra, setExtra] = useState(0);

  useEffect(() => {
    const box = ref.current?.parentElement;
    if (!src || !box) return undefined;
    let img = null;
    let cancelled = false;

    const measure = () => {
      if (!img || cancelled) return;
      try {
        const { width, height } = box.getBoundingClientRect();
        const result = measureHero(img, { width, height });
        if (result) setExtra(result.extra);
      } catch {
        // The photo can't be read (another site's image): keep the gradient only.
      }
    };

    loadForMeasuring(src)
      .then((loaded) => {
        img = loaded;
        measure();
      })
      .catch(() => {});

    let timer;
    const onResize = () => {
      clearTimeout(timer);
      timer = setTimeout(measure, 200);
    };
    window.addEventListener('resize', onResize);
    return () => {
      cancelled = true;
      clearTimeout(timer);
      window.removeEventListener('resize', onResize);
    };
  }, [src]);

  return (
    <div
      ref={ref}
      className="absolute inset-0 bg-background transition-opacity duration-500"
      style={{ opacity: extra }}
    />
  );
}

HeroScrim.propTypes = {
  src: PropTypes.string,
};
